import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ErrorTrackingApplyPromotionViewPage from "./pages/ErrorTrackingApplyPromotionViewPage.vue";
import ErrorTrackingIncorrectInventoryViewPage from "./pages/ErrorTrackingIncorrectInventoryViewPage.vue";
import ErrorTrackingIncorrectInventoryDetailPage from "./pages/ErrorTrackingIncorrectInventoryDetailPage.vue";

export const ErrorTrackingRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "error-tracking"
) => [
  {
    name: "ErrorTrackingApplyPromotionViewPage",
    path: `${prefix}/apply-promotion`,
    component: ErrorTrackingApplyPromotionViewPage,
    meta: { title: "Error Tracking Apply Promotion" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.APPLY_PROMOTION_ERROR_TRACKING_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ErrorTrackingIncorrectInventoryViewPage",
    path: `${prefix}/incorrect-inventory`,
    component: ErrorTrackingIncorrectInventoryViewPage,
    meta: { title: "Error Tracking Incorrect Inventory" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.INCORRECT_INVENTORY_ERROR_TRACKING_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "ErrorTrackingIncorrectInventoryDetailPage",
    path: `${prefix}/incorrect-inventory/:id`,
    component: ErrorTrackingIncorrectInventoryDetailPage,
    meta: { title: "Error Tracking Incorrect Inventory Detail" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.INCORRECT_INVENTORY_ERROR_TRACKING_VIEW
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
